import { render } from "./NewsPage.vue?vue&type=template&id=7859637b&scoped=true&ts=true"
import script from "./NewsPage.vue?vue&type=script&lang=ts"
export * from "./NewsPage.vue?vue&type=script&lang=ts"

import "./NewsPage.vue?vue&type=style&index=0&id=7859637b&lang=scss&scoped=true"

import exportComponent from "/home/administrator/tourstat-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7859637b"]])

export default __exports__